import { useQuery } from "@tanstack/react-query";
import { reviewerApi, apiBaseConfigured, type InquiryResult } from "@/lib/api";

/**
 * Fetches the operator-facing rich detail for one inquiry, including
 * per-signal `verified_at` timestamps, the voucher invitations list, and
 * the inquiry's submitted_at / decided_at. Used by the unified Applicant
 * page to populate the activity timeline.
 */
export function useInquiryResult(inquiryId: string | undefined) {
  const enabled = apiBaseConfigured() && Boolean(inquiryId);

  const query = useQuery({
    queryKey: ["reviewer", "inquiry-result", inquiryId],
    queryFn: () => reviewerApi.getInquiryResult(inquiryId as string),
    enabled,
    retry: 1,
    staleTime: 30_000,
    // Keep previous data visible across remounts so the page doesn't flash
    // a skeleton when revisited.
    placeholderData: (prev) => prev,
  });

  return {
    result: (query.data ?? null) as InquiryResult | null,
    loading: enabled && query.isLoading,
    error: (query.error as Error) ?? null,
    refetch: () => query.refetch(),
  };
}
